module.exports = __webpack_public_path__ + "3d11375ad2bc86751a8fc23ba33267a8.png";